import $ from 'jquery';
import { BREAKPOINTS } from "./breakpoints";
import WindowUtil from "./windowUtil";
import Swiper, { Navigation, Pagination, Thumbs, FreeMode, Lazy } from 'swiper';

export default class FrontPage {
    constructor() {
        this.windowUtil = new WindowUtil();

        this.spacesSwiper = null;
        this.isExistSpacesSwiperInstance = false;

        this.casesSwiper = null;
        this.isExistCasesSwiperInstance = false;
        this.casesSwiperMode = 'small';

        this.handleFrontPageSwiper();
    }

    initFrontPageSwiper(modules, el, options) {
        if ($(el).length) {
            // configure Swiper to use modules
            Swiper.use(modules);
            // init Swiper:
            return new Swiper(el, options);
        } else {
            return;
        }
    }

    handleFrontPageSwiper() {
        // スペース紹介
        const spacesSwiperModlues = [Pagination, Lazy];
        const spacesSwiperContainer = '[data-swiper-element="frontPageSpaceGallerry"]';
        const spacesSwiperOptions = {
            loop: true,
            slidesPerView: 1.3,
            spaceBetween: 0,
            pagination: {
                el: '.swiper-pagination',
                dynamicBullets: true,
                dynamicMainBullets: 3
            },
            preloadImages: false,
            lazy: true,
            watchSlidesProgress: true
        };
        // 事例紹介
        const casesSwiperModlues = [Navigation, Pagination, Lazy];
        const casesSwiperContainer = '[data-swiper-element="frontPageCases"]';
        const casesSwiperOptions = {
            loop: false,
            slidesPerView: 1.3,
            spaceBetween: 24,
            pagination: {
                el: '.swiper-pagination',
                dynamicBullets: true,
                dynamicMainBullets: 3
            },
            preloadImages: false,
            lazy: true,
            watchSlidesProgress: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        };

        // mediaQuery初期チェック
        // mediumサイズ以上ではスペース紹介のswiper(spacesSwiper)は使わない
        if (this.windowUtil.matchMediaQueryXsmall.matches || this.windowUtil.matchMediaQuerySmall.matches) {
            this.spacesSwiper = this.initFrontPageSwiper(spacesSwiperModlues, spacesSwiperContainer, spacesSwiperOptions);
            // 実際に this.spacesSwiper にインスタンスが入っているかどうかでtrueフラグを立てる。
            // front-page以外で該当要素が存在しない場合はインスタンスが作られない。その場合にフラグだけ立ってしまうとバグとなるため。
            // 前提として、swiper.destroyしてもインスタンスそのものは残るようなので this.spacesSwiper の有無判定ではなくisExistフラグを用意している
            this.isExistSpacesSwiperInstance = !!this.spacesSwiper;
            this.adjustSpacesSwiperToLargerMediumSize(false);

            casesSwiperOptions.slidesPerView = 1.3;
            this.casesSwiper = this.initFrontPageSwiper(casesSwiperModlues, casesSwiperContainer, casesSwiperOptions);
            // casesSwiperは初期読み込み時にインスタンス作成してisExistフラグを立てたらそのままでよい（画面サイズに関係なくswiper使うため）
            // spacesSwiperの方は画面サイズによってswiper使う/使わないがあるためmediaQueryのchangeで新たにインスタンス作成した場合はisExistフラグを立てている
            this.isExistCasesSwiperInstance = !!this.casesSwiper;
            this.casesSwiperMode = 'small';
        } else if (this.windowUtil.matchMediaQueryMedium.matches) {
            this.adjustSpacesSwiperToLargerMediumSize(true);

            casesSwiperOptions.slidesPerView = 2.3;
            this.casesSwiper = this.initFrontPageSwiper(casesSwiperModlues, casesSwiperContainer, casesSwiperOptions);
            this.isExistCasesSwiperInstance = !!this.casesSwiper;
            this.casesSwiperMode = 'medium';
        } else {
            this.adjustSpacesSwiperToLargerMediumSize(true);

            casesSwiperOptions.slidesPerView = 3;
            this.casesSwiper = this.initFrontPageSwiper(casesSwiperModlues, casesSwiperContainer, casesSwiperOptions);
            this.isExistCasesSwiperInstance = !!this.casesSwiper;
            this.casesSwiperMode = 'large';
        }

        // mediaQueryのchangeをウォッチする
        this.windowUtil.matchMediaQueryXsmall.addEventListener('change', (e) => {
            if (e.matches) {
                if (!this.isExistSpacesSwiperInstance) {
                    this.spacesSwiper = this.initFrontPageSwiper(spacesSwiperModlues, spacesSwiperContainer, spacesSwiperOptions);
                    this.isExistSpacesSwiperInstance = !!this.spacesSwiper;
                    this.adjustSpacesSwiperToLargerMediumSize(false);
                }
                // front-page以外の場合初期読み込み時点でインスタンスを作成していない場合があるため存在確認する必要がある（存在しないまま進むと.destroyでコケる）
                if (this.isExistCasesSwiperInstance && this.casesSwiperMode !== 'small') {
                    this.casesSwiper.destroy(false, true);
                    casesSwiperOptions.slidesPerView = 1.3;
                    this.casesSwiper = this.initFrontPageSwiper(casesSwiperModlues, casesSwiperContainer, casesSwiperOptions);
                    this.casesSwiperMode = 'small';
                }
            }
        });
        this.windowUtil.matchMediaQuerySmall.addEventListener('change', (e) => {
            if (e.matches) {
                if (!this.isExistSpacesSwiperInstance) {
                    this.spacesSwiper = this.initFrontPageSwiper(spacesSwiperModlues, spacesSwiperContainer, spacesSwiperOptions);
                    this.isExistSpacesSwiperInstance = !!this.spacesSwiper;
                    this.adjustSpacesSwiperToLargerMediumSize(false);
                }
                if (this.isExistCasesSwiperInstance && this.casesSwiperMode !== 'small') {
                    this.casesSwiper.destroy(false, true);
                    casesSwiperOptions.slidesPerView = 1.3;
                    this.casesSwiper = this.initFrontPageSwiper(casesSwiperModlues, casesSwiperContainer, casesSwiperOptions);
                    this.casesSwiperMode = 'small';
                }
            }
        });
        this.windowUtil.matchMediaQueryMedium.addEventListener('change', (e) => {
            if (e.matches) {
                if (this.isExistSpacesSwiperInstance) {
                    this.spacesSwiper.destroy(false, true);
                    this.isExistSpacesSwiperInstance = false;
                    this.adjustSpacesSwiperToLargerMediumSize(true);
                }
                if (this.isExistCasesSwiperInstance && this.casesSwiperMode !== 'medium') {
                    this.casesSwiper.destroy(false, true);
                    casesSwiperOptions.slidesPerView = 2.3;
                    this.casesSwiper = this.initFrontPageSwiper(casesSwiperModlues, casesSwiperContainer, casesSwiperOptions);
                    this.casesSwiperMode = 'medium';
                }
            }
        });
        this.windowUtil.matchMediaQueryLarge.addEventListener('change', (e) => {
            if (e.matches) {
                if (this.isExistSpacesSwiperInstance) {
                    this.spacesSwiper.destroy(false, true);
                    this.isExistSpacesSwiperInstance = false;
                    this.adjustSpacesSwiperToLargerMediumSize(true);
                }
                if (this.isExistCasesSwiperInstance && this.casesSwiperMode !== 'large') {
                    this.casesSwiper.destroy(false, true);
                    casesSwiperOptions.slidesPerView = 3;
                    this.casesSwiper = this.initFrontPageSwiper(casesSwiperModlues, casesSwiperContainer, casesSwiperOptions);
                    this.casesSwiperMode = 'large';
                }
            }
        });
        this.windowUtil.matchMediaQueryXlarge.addEventListener('change', (e) => {
            if (e.matches) {
                if (this.isExistSpacesSwiperInstance) {
                    this.spacesSwiper.destroy(false, true);
                    this.isExistSpacesSwiperInstance = false;
                    this.adjustSpacesSwiperToLargerMediumSize(true);
                }
                if (this.isExistCasesSwiperInstance && this.casesSwiperMode !== 'large') {
                    this.casesSwiper.destroy(false, true);
                    casesSwiperOptions.slidesPerView = 3;
                    this.casesSwiper = this.initFrontPageSwiper(casesSwiperModlues, casesSwiperContainer, casesSwiperOptions);
                    this.casesSwiperMode = 'large';
                }
            }
        });
    }

    adjustSpacesSwiperToLargerMediumSize(bool) {
        $('.swiper-wrapper', '[data-swiper-element="frontPageSpaceGallerry"]').toggleClass('row', bool);
        if (bool) {
            $('img.swiper-lazy', '[data-swiper-element="frontPageSpaceGallerry"]').each((i, el) => {
                const dataSrc = $(el).attr('data-src');
                const dataSrcset = $(el).attr('data-srcset');
                $(el).attr({
                    src: dataSrc,
                    srcset: dataSrcset
                });
            });
            $('[data-swiper-element-container]').removeAttr('style');
        } else {
            $('[data-swiper-element-container]').attr({
                style: 'padding-left: 0; padding-right: 0;'
            });
        }
    }
};
